var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPostitSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-postit-sheet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.811,
    height: 123.721,
    viewBox: "0 0 92.811 123.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2110",
    "data-name": "Ret\\xE2ngulo 2110",
    width: 92.811,
    height: 123.721,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1857",
    "data-name": "Caminho 1857",
    d: "M67.649,98.661H78.095L67.649,109.107ZM55.524,65.3c1.869-.714,2.414-2.277,2.41-4.175q-.03-19.209-.01-38.417v-9.34H81.362c.018.406.055.833.056,1.251q0,4.048,0,8.094c.007,1.428.682,2.214,1.826,2.192,1.1-.02,1.754-.793,1.793-2.135.013-.519,0-1.04,0-1.644h4.047v98.89H13.424V115.98h1.47q24.221,0,48.443.02a7.217,7.217,0,0,0,5.487-2.279q6.949-7.061,14.009-14.009a7.115,7.115,0,0,0,2.232-5.386q-.041-31.229-.017-62.458a9.177,9.177,0,0,0-.021-1.086,1.858,1.858,0,0,0-1.847-1.726,1.8,1.8,0,0,0-1.744,1.8c-.027.4-.013.8-.013,1.208v62.87H80.061c-3.986,0-7.974-.007-11.959,0a3.728,3.728,0,0,0-4.109,3.3,3.788,3.788,0,0,0,0,.813c-.015,3.947,0,7.893,0,11.84v1.383H5.659V65.615h17.69q14.844,0,29.685-.013v.008c.127.006.254.01.38.01a7.089,7.089,0,0,0,2.11-.32m-44.1-36.175c0-.023,0-.045,0-.069h.006q-.12-9.845,0-19.692A5.872,5.872,0,0,1,22.91,7.737c-1.714,0-3.382-.007-5.05,0-1.475.008-2.354.725-2.319,1.865.036,1.1.867,1.754,2.3,1.754q17.4.007,34.794,0h1.553V61.908H3.7V11.473H7.778v1.263c0,5.4-.065,10.793.02,16.188A9.536,9.536,0,0,0,22.147,37.18a9.068,9.068,0,0,0,4.717-7.931c.077-2.7.063-5.4.017-8.094a5.631,5.631,0,0,0-5.572-5.663A5.721,5.721,0,0,0,15.547,21c-.073,1.284-.05,2.577-.011,3.865a1.809,1.809,0,0,0,1.627,1.975,1.687,1.687,0,0,0,.19.008c1.071,0,1.759-.734,1.784-1.983.027-1.127-.013-2.262.015-3.383a2.142,2.142,0,0,1,1.915-2.347c.049,0,.1-.008.145-.01a2.083,2.083,0,0,1,2.059,2.108,1.9,1.9,0,0,1-.014.232c.02,2.5.04,5-.008,7.49a5.833,5.833,0,0,1-5.779,5.886h-.214a5.834,5.834,0,0,1-5.83-5.713M15.965,0A10,10,0,0,0,8.9,5.153c-.413.813-.7,1.689-1.071,2.59-1.237,0-2.483-.01-3.728,0A3.81,3.81,0,0,0,.037,11.274a4.072,4.072,0,0,0,0,.552c-.015,2.416,0,4.832,0,7.248q0,21.08-.006,42.159v.03A3.705,3.705,0,0,0,1.14,64.421a2.353,2.353,0,0,1,.843,2.2q-.021,22.412-.012,44.818c0,3.135,1.42,4.538,4.588,4.541H9.714v3.061c0,3.324,1.36,4.68,4.69,4.68h73.69c3.333,0,4.694-1.352,4.694-4.669V21.687a3.865,3.865,0,0,0-4.264-4.267c-1.115-.006-2.233,0-3.477,0V14.2c0-3.074-1.439-4.523-4.5-4.523H74.914q-8.175,0-16.353-.018a2.017,2.017,0,0,1-1.368-.419,4.525,4.525,0,0,0-3.655-1.5c-8.576.021-17.153,0-25.729.025-.745,0-1.109-.138-1.334-.952a8.429,8.429,0,0,0-3.786-5.118A30.58,30.58,0,0,0,18.865,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1859",
    "data-name": "Caminho 1859",
    d: "M24.138,68.4a1.379,1.379,0,0,0-1.29,1.344,1.365,1.365,0,0,0,1.036,1.543,4.375,4.375,0,0,0,1.2.121q17.15.009,34.3,0a4.437,4.437,0,0,0,1.2-.117,1.481,1.481,0,0,0-.225-2.888,7.15,7.15,0,0,0-.914-.035H25.15c-.085,0-.17,0-.255,0q-.38,0-.757.035",
    transform: "translate(-22.831 -68.362)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1861",
    "data-name": "Caminho 1861",
    d: "M24.145,60.263a1.484,1.484,0,0,0-.163,2.915,4.954,4.954,0,0,0,1.106.091q17.151.007,34.3,0h.066a4.986,4.986,0,0,0,.945-.059,1.492,1.492,0,0,0-.13-2.959c-.214-.021-.43-.025-.646-.025h-.366v0h-34c-.1,0-.191,0-.287,0-.276,0-.551.012-.827.038",
    transform: "translate(-22.847 -60.225)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1863",
    "data-name": "Caminho 1863",
    d: "M46.789,76.491H46.6V76.5H25.312c-.337,0-.676-.007-1.014.014a1.439,1.439,0,0,0-1.455,1.4,1.512,1.512,0,0,0,1.372,1.6,4.519,4.519,0,0,0,.708.022q10.8,0,21.594-.006h.189a1.491,1.491,0,0,0,.976-.178,2.9,2.9,0,0,0,.894-1.518c.088-.687-.45-1.173-1.167-1.3a3.425,3.425,0,0,0-.545-.044h-.075",
    transform: "translate(-22.84 -76.49)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1865",
    "data-name": "Caminho 1865",
    d: "M12.953,76.513h0a1.478,1.478,0,0,0-1.516,1.438v.01a1.4,1.4,0,0,0,1.273,1.526l.047,0a23.026,23.026,0,0,0,3.639,0A1.352,1.352,0,0,0,17.7,78.1a1.026,1.026,0,0,0-.012-.136,1.377,1.377,0,0,0-1.32-1.435h-.079c-.57-.046-1.148-.009-1.72-.009v-.006c-.335,0-.672-.01-1.007-.01-.2,0-.41,0-.613.015",
    transform: "translate(-11.434 -76.498)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1867",
    "data-name": "Caminho 1867",
    d: "M56.655,21.2v0a1.337,1.337,0,0,0-1.262,1.408,1.262,1.262,0,0,0,.019.161,1.387,1.387,0,0,0,1.379,1.4c.02,0,.04,0,.061,0,.537.034,1.08.007,1.618.006h.537c.4,0,.79.009,1.184-.009a1.4,1.4,0,0,0,1.454-1.344v-.051a1.355,1.355,0,0,0-1.121-1.555c-.044-.007-.089-.012-.133-.015-.617-.053-1.24-.08-1.861-.08s-1.254.027-1.876.081",
    transform: "translate(-55.392 -21.123)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1869",
    "data-name": "Caminho 1869",
    d: "M56.566,29.386l0-.009A1.31,1.31,0,0,0,55.384,30.8a1.443,1.443,0,0,0,.036.2,1.374,1.374,0,0,0,1.428,1.3c.538.028,1.079.005,1.619.005.574,0,1.147.018,1.72,0a1.4,1.4,0,0,0,1.459-1.338v-.049A1.306,1.306,0,0,0,60.6,29.4q-.054-.009-.108-.015c-.672-.058-1.348-.089-2.025-.089-.637,0-1.274.028-1.9.086",
    transform: "translate(-55.378 -29.3)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1871",
    "data-name": "Caminho 1871",
    d: "M12.848,68.388h0a1.386,1.386,0,0,0-1.39,1.35,1.3,1.3,0,0,0,1.012,1.536c.038.007.076.013.116.018a22.915,22.915,0,0,0,4.024-.009c.8-.074,1.163-.766,1.081-1.577a1.34,1.34,0,0,0-1.3-1.307c-.6-.053-1.212-.011-1.82-.011v-.007c-.353,0-.709-.011-1.062-.011-.219,0-.439,0-.656.017",
    transform: "translate(-11.427 -68.371)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1873",
    "data-name": "Caminho 1873",
    d: "M58.509,37.414c-.578,0-1.156.018-1.73.051v0a1.493,1.493,0,0,0,.05,2.979c.535.04,1.078.007,1.618.007v-.006c.607,0,1.216.036,1.82-.008a1.383,1.383,0,0,0,1.385-1.381c0-.025,0-.05,0-.076a1.368,1.368,0,0,0-1.227-1.5l-.106-.006c-.575-.039-1.154-.06-1.733-.06h-.073",
    transform: "translate(-55.41 -37.414)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1875",
    "data-name": "Caminho 1875",
    d: "M14.635,60.224q-.869,0-1.734.025h0a1.425,1.425,0,0,0-1.456,1.393v.007a1.478,1.478,0,0,0,1.369,1.579h.014a15.114,15.114,0,0,0,1.716.012v-.005a15.511,15.511,0,0,0,1.817-.014A1.413,1.413,0,0,0,17.7,61.746c0-.041-.006-.082-.011-.123a1.383,1.383,0,0,0-1.385-1.378q-.037,0-.075,0-.759-.024-1.519-.024h-.08",
    transform: "translate(-11.438 -60.224)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1877",
    "data-name": "Caminho 1877",
    d: "M56.649,45.632v0a1.3,1.3,0,0,0-1.25,1.348,1.036,1.036,0,0,0,.009.112,1.337,1.337,0,0,0,1.216,1.449l.037,0a14.691,14.691,0,0,0,1.817.015v.013c.607,0,1.217.044,1.818-.01a1.383,1.383,0,0,0,1.358-1.407c0-.026,0-.052,0-.077a1.332,1.332,0,0,0-1.2-1.45l-.067,0q-.919-.057-1.845-.057-.947,0-1.89.063",
    transform: "translate(-55.398 -45.569)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1879",
    "data-name": "Caminho 1879",
    d: "M36.994,37.424H11.746v0h-.157c-.272-.006-.584-.011-.721.13a3.18,3.18,0,0,0-1.01,1.453,1.269,1.269,0,0,0,1.127,1.4l.053,0a5.672,5.672,0,0,0,.974.054H36.655A5.345,5.345,0,0,0,37.7,40.4a1.35,1.35,0,0,0,1.152-1.35,1.37,1.37,0,0,0-.961-1.5,2.745,2.745,0,0,0-.829-.129h-.065",
    transform: "translate(-9.85 -37.423)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1881",
    "data-name": "Caminho 1881",
    d: "M29.313,21.147v.009a1.517,1.517,0,0,0-1.593,1.438,1.251,1.251,0,0,0,0,.162,1.5,1.5,0,0,0,1.569,1.426.684.684,0,0,0,.079,0c1.317.021,2.636,0,3.954,0h1.208c.916,0,1.832.008,2.747-.01a1.452,1.452,0,0,0,1.576-1.314,1.436,1.436,0,0,0,.005-.161,1.472,1.472,0,0,0-1.4-1.542c-.045,0-.09,0-.134,0q-2.028-.028-4.055-.028-1.977,0-3.955.025",
    transform: "translate(-27.718 -21.122)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1883",
    "data-name": "Caminho 1883",
    d: "M29.452,29.282h0a1.557,1.557,0,0,0-1.719,1.376,1.5,1.5,0,0,0-.009.2c.025.883.662,1.439,1.716,1.453,1.285.017,2.569,0,3.852,0s2.569.012,3.852,0c1.079-.014,1.684-.539,1.717-1.443a1.525,1.525,0,0,0-1.451-1.595,1.49,1.49,0,0,0-.25.008q-1.917-.021-3.834-.02-1.935,0-3.87.02",
    transform: "translate(-27.719 -29.262)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4101",
    "data-name": "Grupo 4101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4100",
    "data-name": "Grupo 4100",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1856",
    "data-name": "Caminho 1856",
    d: "M67.649,98.661H78.095L67.649,109.107ZM53.035,65.61a7.133,7.133,0,0,0,2.489-.311c1.87-.714,2.414-2.277,2.41-4.175q-.03-19.209-.01-38.417v-9.34H81.362c.019.406.055.833.056,1.251q0,4.048.006,8.094c.006,1.428.681,2.214,1.825,2.192,1.1-.02,1.754-.793,1.793-2.135.014-.519,0-1.04,0-1.644h4.047v98.89H13.424V115.98h1.47q24.223,0,48.444.02a7.216,7.216,0,0,0,5.487-2.279q6.947-7.061,14.009-14.009a7.123,7.123,0,0,0,2.232-5.386q-.043-31.229-.018-62.458a9.176,9.176,0,0,0-.021-1.086,1.857,1.857,0,0,0-1.846-1.726,1.8,1.8,0,0,0-1.745,1.8c-.027.4-.012.8-.012,1.208v62.87H80.062c-3.986,0-7.975-.007-11.96,0a3.728,3.728,0,0,0-4.109,3.3,3.788,3.788,0,0,0,0,.813c-.017,3.947,0,7.893,0,11.84v1.383H5.658V65.615H23.349q14.842,0,29.685-.013m-41.6-36.546q-.12-9.845,0-19.692A5.873,5.873,0,0,1,22.911,7.737c-1.714,0-3.383-.007-5.052,0-1.474.008-2.353.725-2.317,1.865.035,1.1.867,1.754,2.295,1.754q17.4.007,34.794,0h1.553V61.908H3.7V11.473H7.778v1.263c0,5.4-.065,10.793.02,16.188A9.536,9.536,0,0,0,22.147,37.18a9.07,9.07,0,0,0,4.718-7.931c.076-2.7.063-5.4.015-8.094a5.63,5.63,0,0,0-5.572-5.663A5.721,5.721,0,0,0,15.547,21c-.073,1.284-.049,2.577-.011,3.865a1.809,1.809,0,0,0,1.627,1.975c.063.006.127.008.19.008,1.071,0,1.759-.734,1.785-1.983.026-1.127-.014-2.262.014-3.383A2.143,2.143,0,0,1,21.07,19.13c.048,0,.1-.008.144-.01a2.084,2.084,0,0,1,2.06,2.108,2.171,2.171,0,0,1-.015.232c.02,2.5.04,5-.008,7.49a5.833,5.833,0,0,1-5.779,5.886h-.093a5.832,5.832,0,0,1-5.95-5.712c0-.023,0-.046,0-.069M15.965,0A10.005,10.005,0,0,0,8.9,5.153c-.412.813-.7,1.689-1.071,2.59-1.235,0-2.482-.01-3.728,0A3.809,3.809,0,0,0,.038,11.274a3.719,3.719,0,0,0,0,.552c-.017,2.416,0,4.832,0,7.248q0,21.08-.007,42.159v.03a3.707,3.707,0,0,0,1.109,3.158,2.353,2.353,0,0,1,.842,2.2q-.02,22.412-.012,44.818c0,3.135,1.421,4.538,4.588,4.541H9.715v3.061c0,3.324,1.36,4.68,4.69,4.68H88.093c3.333,0,4.7-1.352,4.7-4.669V21.687a3.866,3.866,0,0,0-4.264-4.267c-1.116-.006-2.234,0-3.478,0V14.2c0-3.074-1.438-4.523-4.5-4.523H74.914q-8.175,0-16.352-.018a2.02,2.02,0,0,1-1.369-.419,4.523,4.523,0,0,0-3.654-1.5c-8.577.021-17.153,0-25.73.025-.744,0-1.109-.138-1.333-.952a8.431,8.431,0,0,0-3.787-5.118A30.677,30.677,0,0,0,18.864,0Z",
    transform: "translate(0)",
    fill: "#0d0d0d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon-postit-sheet-2",
    "data-name": "icon-postit-sheet",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4102",
    "data-name": "Grupo 4102",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2111",
    "data-name": "Ret\\xE2ngulo 2111",
    width: 92.767,
    height: 123.72,
    transform: "translate(0.021 0.001)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4105",
    "data-name": "Grupo 4105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4104",
    "data-name": "Grupo 4104",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1858",
    "data-name": "Caminho 1858",
    d: "M45.886,68.367H25.592a9.945,9.945,0,0,0-1.206.037A1.642,1.642,0,0,0,22.852,70a1.622,1.622,0,0,0,1.233,1.837,5.194,5.194,0,0,0,1.428.144q20.414.011,40.826,0a5.342,5.342,0,0,0,1.428-.139,1.763,1.763,0,0,0-.268-3.437,8.321,8.321,0,0,0-1.089-.042H45.886",
    transform: "translate(4.344 13.007)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4107",
    "data-name": "Grupo 4107",
    transform: "translate(31.481 81.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4106",
    "data-name": "Grupo 4106",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2113",
    "data-name": "Ret\\xE2ngulo 2113",
    width: 38.928,
    height: 3.055,
    transform: "translate(-0.048 -0.005)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4109",
    "data-name": "Grupo 4109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4108",
    "data-name": "Grupo 4108",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1860",
    "data-name": "Caminho 1860",
    d: "M66.185,60.23H25.719a10.487,10.487,0,0,0-1.326.04,1.766,1.766,0,0,0-.194,3.47,5.885,5.885,0,0,0,1.316.108q20.413.009,40.826,0h.077a5.928,5.928,0,0,0,1.125-.07,1.776,1.776,0,0,0-.154-3.522c-.255-.025-.512-.03-.769-.03h-.437",
    transform: "translate(4.347 11.459)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4111",
    "data-name": "Grupo 4111",
    transform: "translate(31.498 72.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4110",
    "data-name": "Grupo 4110",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2115",
    "data-name": "Ret\\xE2ngulo 2115",
    width: 38.844,
    height: 3.057,
    transform: "translate(-0.024 -0.008)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4113",
    "data-name": "Grupo 4113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4112",
    "data-name": "Grupo 4112",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1862",
    "data-name": "Caminho 1862",
    d: "M51.12,76.5H25.784c-.4,0-.806-.008-1.207.017a1.713,1.713,0,0,0-1.733,1.666,1.8,1.8,0,0,0,1.633,1.9,5.536,5.536,0,0,0,.843.026q12.855,0,25.7-.007h.224a1.774,1.774,0,0,0,1.162-.212,3.452,3.452,0,0,0,1.064-1.807c.1-.818-.536-1.4-1.388-1.547a4.137,4.137,0,0,0-.738-.051h-.229",
    transform: "translate(4.346 14.554)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4115",
    "data-name": "Grupo 4115",
    transform: "translate(29.328 91.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4114",
    "data-name": "Grupo 4114",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2117",
    "data-name": "Ret\\xE2ngulo 2117",
    width: 25.914,
    height: 3.064,
    transform: "translate(-0.09 0.004)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4117",
    "data-name": "Grupo 4117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4116",
    "data-name": "Grupo 4116",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1864",
    "data-name": "Caminho 1864",
    d: "M13.247,76.517a1.759,1.759,0,0,0-1.806,1.712v.012a1.674,1.674,0,0,0,1.516,1.818l.056,0a27.391,27.391,0,0,0,4.33,0A1.608,1.608,0,0,0,18.9,78.4a1.484,1.484,0,0,0-.013-.162,1.642,1.642,0,0,0-1.572-1.708h-.094c-.678-.055-1.365-.011-2.047-.011V76.51c-.4,0-.8-.012-1.2-.012-.238,0-.487,0-.73.018",
    transform: "translate(2.176 14.555)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4119",
    "data-name": "Grupo 4119",
    transform: "translate(11.434 91.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4118",
    "data-name": "Grupo 4118",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2119",
    "data-name": "Ret\\xE2ngulo 2119",
    width: 6.301,
    height: 3.112,
    transform: "translate(-0.003 -0.02)",
    fill: "#fff"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4121",
    "data-name": "Grupo 4121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4120",
    "data-name": "Grupo 4120",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1866",
    "data-name": "Caminho 1866",
    d: "M56.9,21.224a1.593,1.593,0,0,0-1.5,1.676,1.718,1.718,0,0,0,.023.192,1.651,1.651,0,0,0,1.641,1.66h.073c.64.04,1.285.008,1.927.007H59.7c.476,0,.94.011,1.409-.011a1.666,1.666,0,0,0,1.731-1.6c0-.02,0-.04,0-.061A1.613,1.613,0,0,0,61.5,21.236c-.052-.008-.1-.014-.158-.018-.733-.063-1.475-.1-2.215-.1s-1.493.032-2.233.1",
    transform: "translate(10.539 4.019)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4123",
    "data-name": "Grupo 4123",
    transform: "translate(66.853 25.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4122",
    "data-name": "Grupo 4122",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2121",
    "data-name": "Ret\\xE2ngulo 2121",
    width: 6.362,
    height: 3.078,
    transform: "translate(-0.041 0.004)",
    fill: "#fff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4125",
    "data-name": "Grupo 4125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4124",
    "data-name": "Grupo 4124",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1868",
    "data-name": "Caminho 1868",
    d: "M56.789,29.392a1.557,1.557,0,0,0-1.4,1.7,1.54,1.54,0,0,0,.043.244,1.633,1.633,0,0,0,1.7,1.547c.64.033,1.284.006,1.927.006.683,0,1.366.021,2.047,0a1.667,1.667,0,0,0,1.737-1.594v-.057a1.556,1.556,0,0,0-1.247-1.813q-.064-.011-.129-.018c-.8-.069-1.6-.106-2.41-.106-.758,0-1.515.033-2.262.1",
    transform: "translate(10.537 5.575)",
    fill: "#fff"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4127",
    "data-name": "Grupo 4127",
    transform: "translate(66.839 35.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4126",
    "data-name": "Grupo 4126",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2123",
    "data-name": "Ret\\xE2ngulo 2123",
    width: 6.397,
    height: 3.042,
    transform: "translate(-0.061 -0.009)",
    fill: "#fff"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4129",
    "data-name": "Grupo 4129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4128",
    "data-name": "Grupo 4128",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1870",
    "data-name": "Caminho 1870",
    d: "M13.113,68.392A1.649,1.649,0,0,0,11.46,70a1.548,1.548,0,0,0,1.2,1.828c.045.008.092.017.138.021a27.275,27.275,0,0,0,4.79-.011c.952-.088,1.384-.912,1.287-1.877a1.594,1.594,0,0,0-1.547-1.556c-.714-.063-1.444-.013-2.166-.013v-.008c-.421,0-.844-.013-1.265-.013-.261,0-.521,0-.781.02",
    transform: "translate(2.174 13.009)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4131",
    "data-name": "Grupo 4131",
    transform: "translate(11.427 81.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4130",
    "data-name": "Grupo 4130",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2125",
    "data-name": "Ret\\xE2ngulo 2125",
    width: 6.391,
    height: 3.061,
    transform: "translate(-0.049 -0.024)",
    fill: "#fff"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4133",
    "data-name": "Grupo 4133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4132",
    "data-name": "Grupo 4132",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1872",
    "data-name": "Caminho 1872",
    d: "M57.04,37.471a1.777,1.777,0,0,0,.058,3.546c.638.048,1.283.008,1.926.008v-.007c.722,0,1.447.043,2.166-.01a1.646,1.646,0,0,0,1.649-1.644c0-.03,0-.061,0-.09a1.63,1.63,0,0,0-1.462-1.782q-.062-.005-.125-.007-1.071-.073-2.151-.071c-.687,0-1.375.021-2.058.061",
    transform: "translate(10.543 7.119)",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4135",
    "data-name": "Grupo 4135",
    transform: "translate(66.87 44.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4134",
    "data-name": "Grupo 4134",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2127",
    "data-name": "Ret\\xE2ngulo 2127",
    width: 6.317,
    height: 3.07,
    transform: "translate(-0.058 -0.003)",
    fill: "#fff"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4137",
    "data-name": "Grupo 4137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4136",
    "data-name": "Grupo 4136",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1874",
    "data-name": "Caminho 1874",
    d: "M13.176,60.255a1.7,1.7,0,0,0-1.733,1.658v.008A1.759,1.759,0,0,0,13.072,63.8h.017a18.291,18.291,0,0,0,2.044.014V63.81a18.466,18.466,0,0,0,2.163-.017,1.681,1.681,0,0,0,1.6-1.758c0-.049-.007-.1-.013-.146a1.643,1.643,0,0,0-1.649-1.639l-.088,0q-.952-.03-1.9-.029-1.032,0-2.064.03",
    transform: "translate(2.176 11.459)",
    fill: "#fff"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4139",
    "data-name": "Grupo 4139",
    transform: "translate(11.438 72.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4138",
    "data-name": "Grupo 4138",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2129",
    "data-name": "Ret\\xE2ngulo 2129",
    width: 6.427,
    height: 3.07,
    transform: "translate(-0.093 0.001)",
    fill: "#fff"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4141",
    "data-name": "Grupo 4141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4140",
    "data-name": "Grupo 4140",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1876",
    "data-name": "Caminho 1876",
    d: "M56.887,45.648a1.548,1.548,0,0,0-1.488,1.6,1.259,1.259,0,0,0,.011.133,1.591,1.591,0,0,0,1.447,1.724l.045,0a17.721,17.721,0,0,0,2.163.018v.015c.721,0,1.449.052,2.164-.012a1.646,1.646,0,0,0,1.615-1.675c0-.031,0-.061,0-.092a1.583,1.583,0,0,0-1.427-1.725l-.08-.006q-1.094-.068-2.2-.068-1.127,0-2.25.075",
    transform: "translate(10.541 8.67)",
    fill: "#fff"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4143",
    "data-name": "Grupo 4143",
    transform: "translate(66.858 54.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4142",
    "data-name": "Grupo 4142",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2131",
    "data-name": "Ret\\xE2ngulo 2131",
    width: 6.249,
    height: 3.053,
    transform: "translate(0.007 0.003)",
    fill: "#fff"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4145",
    "data-name": "Grupo 4145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4144",
    "data-name": "Grupo 4144",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1878",
    "data-name": "Caminho 1878",
    d: "M12.106,37.429H11.92c-.325-.007-.7-.013-.859.155a3.785,3.785,0,0,0-1.2,1.729A1.511,1.511,0,0,0,11.2,40.975l.062,0a6.641,6.641,0,0,0,1.161.064H41.756A6.35,6.35,0,0,0,43,40.969a1.606,1.606,0,0,0,1.372-1.607,1.631,1.631,0,0,0-1.144-1.785,3.266,3.266,0,0,0-1.065-.152H12.107",
    transform: "translate(1.874 7.12)",
    fill: "#fff"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4147",
    "data-name": "Grupo 4147",
    transform: "translate(9.85 44.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4146",
    "data-name": "Grupo 4146",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2133",
    "data-name": "Ret\\xE2ngulo 2133",
    width: 29.146,
    height: 3.054,
    transform: "translate(-0.1 -0.008)",
    fill: "#fff"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4149",
    "data-name": "Grupo 4149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4148",
    "data-name": "Grupo 4148",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1880",
    "data-name": "Caminho 1880",
    d: "M29.616,21.162a1.8,1.8,0,0,0-1.895,1.712,1.737,1.737,0,0,0,0,.193,1.786,1.786,0,0,0,1.869,1.7q.046,0,.093-.007c1.569.025,3.138.006,4.708,0h1.438c1.09,0,2.179.01,3.268-.012a1.726,1.726,0,0,0,1.876-1.564,1.708,1.708,0,0,0,.007-.192,1.756,1.756,0,0,0-1.67-1.835c-.054,0-.106,0-.159,0q-2.412-.034-4.825-.033-2.355,0-4.709.03",
    transform: "translate(5.274 4.019)",
    fill: "#fff"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4151",
    "data-name": "Grupo 4151",
    transform: "translate(33.871 25.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4150",
    "data-name": "Grupo 4150",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2135",
    "data-name": "Ret\\xE2ngulo 2135",
    width: 11.198,
    height: 3.068,
    transform: "translate(-0.045 0.009)",
    fill: "#fff"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4153",
    "data-name": "Grupo 4153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4152",
    "data-name": "Grupo 4152",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1882",
    "data-name": "Caminho 1882",
    d: "M29.777,29.286a1.854,1.854,0,0,0-2.046,1.638,2.012,2.012,0,0,0-.011.239c.031,1.051.789,1.713,2.044,1.729,1.528.02,3.057,0,4.585,0s3.057.014,4.585,0c1.284-.017,2-.642,2.043-1.718a1.816,1.816,0,0,0-1.727-1.9,1.9,1.9,0,0,0-.3.011q-2.282-.023-4.565-.024-2.3,0-4.606.024",
    transform: "translate(5.274 5.568)",
    fill: "#fff"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4155",
    "data-name": "Grupo 4155",
    transform: "translate(33.873 34.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4154",
    "data-name": "Grupo 4154",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2137",
    "data-name": "Ret\\xE2ngulo 2137",
    width: 11.197,
    height: 3.067,
    transform: "translate(-0.026 0)",
    fill: "#fff"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4157",
    "data-name": "Grupo 4157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4156",
    "data-name": "Grupo 4156",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1884",
    "data-name": "Caminho 1884",
    d: "M10.192,29.056q-.12-9.845,0-19.692A5.873,5.873,0,0,1,21.671,7.737l4.9.025c-.744,0-1.109-.138-1.333-.952a8.431,8.431,0,0,0-3.787-5.118A30.677,30.677,0,0,0,17.624,0h-2.9A10.005,10.005,0,0,0,7.664,5.153c-.412.813-.7,1.689-1.071,2.59l-.055,3.73v1.263c0,5.4-.065,10.793.02,16.188A9.536,9.536,0,0,0,20.907,37.18a9.07,9.07,0,0,0,4.718-7.931c.076-2.7.063-5.4.015-8.094a5.63,5.63,0,0,0-5.572-5.663A5.721,5.721,0,0,0,14.307,21c-.073,1.284-.049,2.577-.011,3.865a1.809,1.809,0,0,0,1.627,1.975c.063.006.127.008.19.008,1.071,0,1.759-.734,1.785-1.983.026-1.127-.014-2.262.014-3.383A2.143,2.143,0,0,1,19.83,19.13c.048,0,.1-.008.144-.01a2.084,2.084,0,0,1,2.06,2.108,2.171,2.171,0,0,1-.015.232c.02,2.5.04,5-.008,7.49a5.833,5.833,0,0,1-5.779,5.886h-.093a5.832,5.832,0,0,1-5.95-5.712c0-.023,0-.046,0-.069",
    transform: "translate(1.239)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostitSheet);
export default __webpack_public_path__ + "static/media/icon-postit-sheet.e23ad2112bde9abbe661caae924a008d.svg";
export { ForwardRef as ReactComponent };